import React from 'react';

interface Employee {
  name: string;
  date: string;
  descargo: string;
  signature: string;
  evidenceFile?: File;
}

interface EmployeeDischargeProps {
  employee: Employee;
}

const EmployeeDischarge: React.FC<EmployeeDischargeProps> = ({ employee }) => {
  return (
    <div>
      <h2 className="text-lg font-semibold">{employee.name}</h2>
      <p>Fecha: {employee.date}</p>
      <p>Descargo: {employee.descargo}</p>
      <div>
        <h3>Firma:</h3>
        <img src={employee.signature} alt="Firma" />
      </div>
      {employee.evidenceFile && (
        <div>
          <h3>Evidencia:</h3>
          <a href={URL.createObjectURL(employee.evidenceFile)} download="evidencia.pdf">Descargar evidencia</a>
        </div>
      )}
    </div>
  );
};

export default EmployeeDischarge;
